import { useContext } from "react";
import { ConfirmDialogContext } from "context/ConfirmDialogContext";

function useConfirmDialog() {
    return useContext(ConfirmDialogContext);
}

export default useConfirmDialog;